// extracted by mini-css-extract-plugin
export var dividerContainer = "_6c-0";
export var line = "_6c-1";